import React from "react"
import { AudioPlayerContext, player } from "~context/audio-player-context"
import { useRouteChatId } from "~hooks/useActiveChat"
import { ChatScreenNavigationProps } from "./types"
import Chat from "./chat-screen"
import { PageRoot } from "~screens/page-root"

const ChatScreen: React.FC<ChatScreenNavigationProps> = () => {
  const chatKey = useRouteChatId() ?? "default"

  return (
    <PageRoot>
      <AudioPlayerContext.Provider value={player}>
        <Chat key={chatKey} />
      </AudioPlayerContext.Provider>
    </PageRoot>
  )
}

export default ChatScreen
